<template>
    <section class="shop-categories">
        <div class="container">
            <div class="row">
                <div data-aos="fade-up" data-aos-duration="1000" class="section-title">
                    <h2>با نیکارت</h2>
                    <p>میتوانید از اصناف زیر خرید نمایید</p>
                </div>
                <swiper class="carousel" :options="swiperOption">
                    <swiper-slide class="text-center" v-for="i in 18" :key="i">
                        <div class="item">
                            <font-awesome-icon size="2x" icon="apple-alt" />
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data()
        {
            return {
                swiperOption: {
                    slidesPerView: 8,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    }
                }
            };
        }
    };
</script>
<style scoped>
    .shop-categories {
        width: 100%;
        float: left;
    }

        .shop-categories .item {
            margin: 20px auto;
            width: 100px;
            height: 100px;
            float: none;
            background: #f8f8f8;
            border-radius: 100%;
            padding: 30px 20px;
        }
</style>
